import CustomApiError from "./CustomApiError"

export default class NotFoundError extends CustomApiError {
  override message = "Page not found."
}
